import { createContext } from "react";
import type { SlidePageBlockLayout } from "@-/dev.improve.haniverse.lib.slide.pages";

/** One measured block, plus how many blocks its slide has (so measuring knows when it is done). */
export type SlidePageBlockMeasurement = SlidePageBlockLayout & { count: number };

/**
 * How the `<SlidePageBlock>` wrappers inside one rendering of a slide behave:
 *
 *   * `measure` — the hidden copy that measures every block at the page's width;
 *   * `page` — one page, showing only its own blocks (setting blocks mount with the first page);
 *   * `null` — outside a paged slide: every block renders.
 */
export type SlidePageBlockRender =
  | { kind: "measure"; onMeasure: (measurement: SlidePageBlockMeasurement) => void }
  | { blocks: ReadonlySet<number>; isFirstPage: boolean; kind: "page" }
  | null;

export const SlidePageBlockRenderContext = createContext<SlidePageBlockRender>(null);
